import { createStore } from "vuex";
import axios from "../util/axios";
import { ElMessage } from "element-plus";
import i18n from "../i18n/index";
import User from "./User";
import Store from "./Store";
import Member from "./Member";
import Pay from "./Pay";
import Upgrade from "./Upgrade";
import Photo from "./Photo";
import Wall from "./Wall";
import Chat from "./Chat";
import Message from "./Message";
import Report from "./Report";
import Notification from "./Notification";
import GlobalGift from "./GlobalGift";
import ChatConnection from "./ChatConnection";

export default createStore({
  state: {
    lang: localStorage.getItem("lang") || "en",
    general_authority: [],
    silvercard_authority: [],
    goldcard_authority: [],
    ...ChatConnection.state,
  },
  mutations: {
    // 修改语言
    changeLang(state, lang) {
      state.lang = lang;
    },
    // 设置用户权限
    setAuthority(state, data) {
      state.general_authority = data.vip0;
      state.silvercard_authority = data.vip1;
      state.goldcard_authority = data.vip2;
    },

    ...ChatConnection.mutations,
    clearChatSession(state) {
      state.Chat.chatList = [];
      state.Chat.globalChatList = [];
      state.Chat.curUser = {};
      state.Chat.service = {};
      state.Chat.count = 0;
    },
  },
  actions: {
    async logout({ commit }) {
      try {
        const res = await axios.post_form("/member/index/logout", {});
        if (res.data.status != 200) throw new Error("Logout rejected");
      } catch (error) {
        ElMessage.error(i18n.global.t("tips.sendfail"));
        return false;
      }
      commit("logout");
      commit("closeWebsocket");
      commit("clearChatImages");
      commit("clearChatHistory");
      commit("clearChatSession");
      return true;
    },
    // 更新用户信息
    updateUserInfo({ commit, state }) {
      axios.post_form("/member/index/userinfo", {}).then((res) => {
        res = res.data;
        if (res.status == 200) {
          commit("updateUserInfo", res.data);
          let vip = state.User.vip;
          if (vip == 0) {
            commit("setUserAuthority", state.general_authority);
          } else if (vip == 1) {
            commit("setUserAuthority", state.silvercard_authority);
          } else if (vip == 2) {
            commit("setUserAuthority", state.goldcard_authority);
          }
        }
      });
    },
    // 设置用户权限
    updateUserAuthority({ commit, state }) {
      let vip = state.User.vip;
      if (vip == 0) {
        commit("setUserAuthority", state.general_authority);
      } else if (vip == 1) {
        commit("setUserAuthority", state.silvercard_authority);
      } else if (vip == 2) {
        commit("setUserAuthority", state.goldcard_authority);
      }
    },
    ...ChatConnection.actions,
  },
  modules: {
    User,
    Store,
    Member,
    Pay,
    Upgrade,
    Photo,
    Wall,
    Chat,
    Message,
    Report,
    Notification,
    GlobalGift,
  },
});
